import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"60px","text-align":"center","background":"white","color":"rgb(253, 253, 253)"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "50%"
  })
], -1)
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { style: {"text-align":"right","margin-right":"10"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lay_icon = _resolveComponent("lay-icon")!
  const _component_lay_menu_item = _resolveComponent("lay-menu-item")!
  const _component_lay_sub_menu = _resolveComponent("lay-sub-menu")!
  const _component_lay_menu = _resolveComponent("lay-menu")!
  const _component_lay_side = _resolveComponent("lay-side")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_dropdown_menu_item = _resolveComponent("lay-dropdown-menu-item")!
  const _component_lay_dropdown_menu = _resolveComponent("lay-dropdown-menu")!
  const _component_lay_dropdown = _resolveComponent("lay-dropdown")!
  const _component_lay_header = _resolveComponent("lay-header")!
  const _component_databsplay = _resolveComponent("databsplay")!
  const _component_agentList = _resolveComponent("agentList")!
  const _component_generalAgentList = _resolveComponent("generalAgentList")!
  const _component_domainName = _resolveComponent("domainName")!
  const _component_visit = _resolveComponent("visit")!
  const _component_downloads = _resolveComponent("downloads")!
  const _component_error = _resolveComponent("error")!
  const _component_basicInfo = _resolveComponent("basicInfo")!
  const _component_setup = _resolveComponent("setup")!
  const _component_userDownloads = _resolveComponent("userDownloads")!
  const _component_permissions = _resolveComponent("permissions")!
  const _component_role = _resolveComponent("role")!
  const _component_userList = _resolveComponent("userList")!
  const _component_divided = _resolveComponent("divided")!
  const _component_acting = _resolveComponent("acting")!
  const _component_orderDetails = _resolveComponent("orderDetails")!
  const _component_detailsList = _resolveComponent("detailsList")!
  const _component_runningDetails = _resolveComponent("runningDetails")!
  const _component_withdrawList = _resolveComponent("withdrawList")!
  const _component_reviewList = _resolveComponent("reviewList")!
  const _component_paymentSettings = _resolveComponent("paymentSettings")!
  const _component_cardamomAgent = _resolveComponent("cardamomAgent")!
  const _component_cardamomList = _resolveComponent("cardamomList")!
  const _component_measure = _resolveComponent("measure")!
  const _component_adminindex = _resolveComponent("adminindex")!
  const _component_imglog = _resolveComponent("imglog")!
  const _component_lay_body = _resolveComponent("lay-body")!
  const _component_lay_layout = _resolveComponent("lay-layout")!

  return (_openBlock(), _createBlock(_component_lay_layout, { class: "example" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_side, { style: {"width":"auto","flex":"0 0 auto","align-items":"normal"} }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_menu, {
            "selected-key": $setup.selectedKey,
            "onUpdate:selectedKey": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedKey) = $event)),
            tree: $setup.isTree,
            "onUpdate:tree": _cache[1] || (_cache[1] = ($event: any) => (($setup.isTree) = $event)),
            "open-keys": $setup.openKeys6,
            "onUpdate:openKeys": _cache[2] || (_cache[2] = ($event: any) => (($setup.openKeys6) = $event)),
            onChangeSelectedKey: $setup.changeSelectedKey,
            collapse: $setup.collapse,
            style: {"padding-top":"0px"}
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (menu) => {
                return (_openBlock(), _createBlock(_component_lay_sub_menu, {
                  key: menu.pathAlias,
                  id: menu.pathAlias
                }, _createSlots({
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menu.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.menulist, (menu1) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: menu1.pathAlias
                      }, [
                        _createVNode(_component_lay_menu_item, {
                          id: menu1.pathAlias
                        }, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menu1.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["id"])
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, [
                  (menu.icon != null)
                    ? {
                        name: "icon",
                        fn: _withCtx(() => [
                          _createVNode(_component_lay_icon, {
                            type: menu.icon
                          }, null, 8, ["type"])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["id"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-key", "tree", "open-keys", "onChangeSelectedKey", "collapse"])
        ]),
        _: 1
      }),
      _createVNode(_component_lay_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_lay_header, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createVNode(_component_lay_icon, {
                    type: $setup.collapse ? 'layui-icon-spread-left' : 'layui-icon-shrink-right',
                    size: "lg",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.menuSize($setup.collapse)))
                  }, null, 8, ["type"]),
                  _createVNode(_component_lay_icon, {
                    type: "layui-icon-home",
                    size: "lg",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.frontPage())),
                    style: {"margin-left":"20px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_lay_dropdown, {
                    trigger: "hover",
                    updateAtScroll: ""
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_lay_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_dropdown_menu_item, { onClick: $setup.changePassword }, {
                            default: _withCtx(() => [
                              _createTextVNode("修改密码")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_lay_dropdown_menu_item, { onClick: $setup.quit }, {
                            default: _withCtx(() => [
                              _createTextVNode("退出")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, { style: {"border-color":"transparent"} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.userName) + " ", 1),
                          _createVNode(_component_lay_icon, {
                            type: "layui-icon-down",
                            style: {"margin-right":"10"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_lay_body, null, {
            default: _withCtx(() => [
              ($setup.viewsType == 0)
                ? (_openBlock(), _createBlock(_component_databsplay, { key: 0 }))
                : ($setup.viewsType == 2)
                  ? (_openBlock(), _createBlock(_component_agentList, { key: 1 }))
                  : ($setup.viewsType == 3)
                    ? (_openBlock(), _createBlock(_component_generalAgentList, { key: 2 }))
                    : ($setup.viewsType == 5)
                      ? (_openBlock(), _createBlock(_component_domainName, { key: 3 }))
                      : ($setup.viewsType == 7)
                        ? (_openBlock(), _createBlock(_component_visit, { key: 4 }))
                        : ($setup.viewsType == 8)
                          ? (_openBlock(), _createBlock(_component_downloads, { key: 5 }))
                          : ($setup.viewsType == 9)
                            ? (_openBlock(), _createBlock(_component_error, { key: 6 }))
                            : ($setup.viewsType == 11)
                              ? (_openBlock(), _createBlock(_component_basicInfo, { key: 7 }))
                              : ($setup.viewsType == 12)
                                ? (_openBlock(), _createBlock(_component_setup, { key: 8 }))
                                : ($setup.viewsType == 13)
                                  ? (_openBlock(), _createBlock(_component_userDownloads, { key: 9 }))
                                  : ($setup.viewsType == 15)
                                    ? (_openBlock(), _createBlock(_component_permissions, { key: 10 }))
                                    : ($setup.viewsType == 16)
                                      ? (_openBlock(), _createBlock(_component_role, { key: 11 }))
                                      : ($setup.viewsType == 18)
                                        ? (_openBlock(), _createBlock(_component_userList, { key: 12 }))
                                        : ($setup.viewsType == 20)
                                          ? (_openBlock(), _createBlock(_component_divided, { key: 13 }))
                                          : ($setup.viewsType == 21)
                                            ? (_openBlock(), _createBlock(_component_acting, { key: 14 }))
                                            : ($setup.viewsType == 23)
                                              ? (_openBlock(), _createBlock(_component_orderDetails, { key: 15 }))
                                              : ($setup.viewsType == 24)
                                                ? (_openBlock(), _createBlock(_component_detailsList, { key: 16 }))
                                                : ($setup.viewsType == 25)
                                                  ? (_openBlock(), _createBlock(_component_runningDetails, { key: 17 }))
                                                  : ($setup.viewsType == 27)
                                                    ? (_openBlock(), _createBlock(_component_withdrawList, { key: 18 }))
                                                    : ($setup.viewsType == 28)
                                                      ? (_openBlock(), _createBlock(_component_reviewList, { key: 19 }))
                                                      : ($setup.viewsType == 29)
                                                        ? (_openBlock(), _createBlock(_component_paymentSettings, { key: 20 }))
                                                        : ($setup.viewsType == 31)
                                                          ? (_openBlock(), _createBlock(_component_cardamomAgent, { key: 21 }))
                                                          : ($setup.viewsType == 32)
                                                            ? (_openBlock(), _createBlock(_component_cardamomList, { key: 22 }))
                                                            : ($setup.viewsType == 33)
                                                              ? (_openBlock(), _createBlock(_component_measure, { key: 23 }))
                                                              : ($setup.viewsType == 34)
                                                                ? (_openBlock(), _createBlock(_component_adminindex, { key: 24 }))
                                                                : ($setup.viewsType == 35)
                                                                  ? (_openBlock(), _createBlock(_component_imglog, { key: 25 }))
                                                                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}